import React, { useEffect, useState, useCallback } from 'react';
import { useAuth } from '../components/AuthContext';
import ProductGrid from '../components/ProductGrid';
import { MdViewModule, MdViewList } from 'react-icons/md';
import API from '../api';
import { useEventTracking } from '../hooks/useAnalytics';
import { Link } from 'react-router-dom';

const LoverlistPage = () => {
  const { isLoggedIn, user } = useAuth();
  const { trackEvent } = useEventTracking();
  const [productIds, setProductIds] = useState([]);
  const [loading, setLoading] = useState(true);
  const [view, setView] = useState('grid');

  const fetchWishlist = useCallback(async () => {
    setLoading(true);
    try {
      if (isLoggedIn) {
        const res = await API.get('/wishlist');
        const ids = res.data.wishlist.map(item => item.product_id);
        console.log('[LoverlistPage] Wishlist utente loggato:', ids);
        setProductIds(ids);
      } else {
        const session_id = localStorage.getItem('wishlist_session_id');
        if (session_id) {
          const res = await API.get('/wishlist/guest', { params: { session_id } });
          const ids = res.data.wishlist.map(item => item.product_id);
          console.log('[LoverlistPage] Wishlist guest:', ids);
          setProductIds(ids);
        } else {
          console.log('[LoverlistPage] Nessuna wishlist guest trovata');
          setProductIds([]);
        }
      }
    } catch (err) {
      console.error('[LoverlistPage] Errore nel caricamento wishlist:', err);
      setProductIds([]);
    } finally {
      setLoading(false);
    }
  }, [isLoggedIn, user]);

  useEffect(() => {
    fetchWishlist();
  }, [fetchWishlist]);

  // Traccia la visualizzazione della wishlist quando i dati sono caricati
  useEffect(() => {
    if (!loading) {
      trackEvent('wishlist_view', {
        product_count: productIds.length,
        is_logged_in: isLoggedIn
      });
    }
  }, [loading, productIds.length, isLoggedIn, trackEvent]);

  return (
    <div className="loverlist-page main-content-container">
      <div className="loverlist-page-header">
        <h1>La tua Loverlist</h1>
        {!isLoggedIn && (
          <div className="loverlist-login-invite">
            <div className="loverlist-login-text">
              Accedi al tuo account per salvare la tua Loverlist su tutti i dispositivi.
            </div>
            <div className="loverlist-login-buttons">
              <Link 
                to="/login" 
                className="btn btn-primary"
                onClick={() => trackEvent('wishlist_cta_click', {
                  element_type: 'cta',
                  element_text: 'Accedi',
                  page_location: 'wishlist_page',
                  destination: '/login'
                })}
              >
                Accedi
              </Link>
              <Link 
                to="/signup" 
                className="btn btn-secondary"
                onClick={() => trackEvent('wishlist_cta_click', {
                  element_type: 'cta',
                  element_text: 'Registrati',
                  page_location: 'wishlist_page',
                  destination: '/signup'
                })}
              >
                Registrati
              </Link>
            </div>
          </div>
        )}
      </div>
      
      <div className="loverlist-page-content">
        {/* Toolbar mobile (max-width: 991px) */}
        <div className="products-toolbar toolbar-mobile-custom">
          <div className="toolbar-mobile-row1">
            <div className="loverlist-count">
              {productIds.length} {productIds.length === 1 ? 'prodotto' : 'prodotti'}
            </div>
          </div>
          <div className="toolbar-mobile-row2">
            <div className="view-toggle-pill">
              <div className="view-toggle-group">
                <button
                  className={`view-toggle${view === 'grid' ? ' active' : ''}`}
                  onClick={() => setView('grid')}
                  type="button"
                  aria-label="Vista griglia"
                >
                  <MdViewModule size={22} />
                </button>
                <button
                  className={`view-toggle${view === 'list' ? ' active' : ''}`}
                  onClick={() => setView('list')}
                  type="button"
                  aria-label="Vista lista"
                >
                  <MdViewList size={22} />
                </button>
              </div>
            </div>
          </div>
        </div>

        {/* Toolbar desktop (min-width: 992px) */}
        <div className="products-toolbar toolbar-desktop-only">
          <div className="loverlist-count">
            {productIds.length} {productIds.length === 1 ? 'prodotto' : 'prodotti'}
          </div>
          <div className="view-toggle-pill">
            <div className="view-toggle-group">
              <button
                className={`view-toggle${view === 'grid' ? ' active' : ''}`}
                onClick={() => setView('grid')}
                type="button"
                aria-label="Vista griglia"
              >
                <MdViewModule size={22} />
              </button>
              <button
                className={`view-toggle${view === 'list' ? ' active' : ''}`}
                onClick={() => setView('list')}
                type="button"
                aria-label="Vista lista"
              >
                <MdViewList size={22} />
              </button>
            </div>
          </div>
        </div>

        <div className="loverlist-products">
          <ProductGrid
            mode="custom"
            productIds={productIds}
            loading={loading}
            view={view}
          />
        </div>
      </div>
    </div>
  );
};

export default LoverlistPage; 